//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  signal,
  WritableSignal,
} from "@angular/core";

//local imports
import {
  AbstractCategoryModel,
  AbstractCategoryNavModel,
} from "@app/catalog-common";
import { Messenger, PresenterRegistration } from "@app/shared";

@PresenterRegistration({
  types: [AbstractCategoryNavModel],
  key: "subMenu",
})
@Component({
  selector: "categories-submenu",
  standalone: false,
  templateUrl: "./categories-submenu.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoriesSubmenuComponent<TCategory extends AbstractCategoryModel> {
  public data: WritableSignal<AbstractCategoryNavModel<TCategory>> = signal<AbstractCategoryNavModel<TCategory>>(null);

  constructor(private messenger: Messenger) {}
}
